import {
  CUSTOMER_STATUS_LOADING,
  CUSTOMER_STATUS_GET_ALL_SUCCESS,
  CUSTOMER_STATUS_ERROR,
  CUSTOMER_STATUS_CLEAR_SNACKBAR,
} from "../constants/types";

const initialState = {
  customer_statusList: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const customer_statusReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_STATUS_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case CUSTOMER_STATUS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMER_STATUS_ERROR:
      return {
        ...state,
        customer_statusList: [],
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };
    case CUSTOMER_STATUS_GET_ALL_SUCCESS:
      return {
        ...state,
        customer_statusList: action.payload.customer_statusList,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };
    default:
      return state || {};
  }
};

export default customer_statusReducer;
